import { z } from 'zod'

/** Get a day of the week. */
export const Day = z.enum([
    'MONDAY',
    'TUESDAY',
    'WEDNESDAY',
    'THURSDAY',
    'FRIDAY',
    'SATURDAY',
    'SUNDAY',
])

export type Day = z.infer<typeof Day>
